export default {
  computed: {
    viewportOffset() {
      const zeroOffset = 0;
      const offset = 156;
      const isLandscape = this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height;
      if (this.$vuetify.breakpoint.smAndDown && !isLandscape) {
        const mobileOverlayAvailable = typeof this.mobileOverlayAvailable !== 'undefined'
          ? this.mobileOverlayAvailable
          : (this.exteriors && this.$vuetify.breakpoint.smAndDown);

        if (!mobileOverlayAvailable) {
          return zeroOffset;
        }

        const overlaysByLinkedExteriors = typeof this.overlaysByLinkedExteriors !== 'undefined'
          ? this.overlaysByLinkedExteriors
          : (this.currentExterior ? (this.currentExterior.overlays || []) : []);

        if (overlaysByLinkedExteriors && overlaysByLinkedExteriors.length === 0) {
          return zeroOffset;
        }
        return offset;
      }
      return zeroOffset;
    },
  },
};
